import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Partners() {
  const { t } = useTranslation('home');
  const [selectedPartner, setSelectedPartner] = useState<any>(null);

  const partners = [
    { 
      name: t('partners.list.0.name'),
      color: 'from-blue-500 to-blue-600',
      description: t('partners.list.0.description'),
      cooperation: t('partners.list.0.cooperation')
    },
    { 
      name: t('partners.list.1.name'),
      color: 'from-orange-500 to-orange-600',
      description: t('partners.list.1.description'),
      cooperation: t('partners.list.1.cooperation')
    },
    { 
      name: t('partners.list.2.name'),
      color: 'from-teal-500 to-teal-600',
      description: t('partners.list.2.description'),
      cooperation: t('partners.list.2.cooperation')
    },
    { 
      name: t('partners.list.3.name'),
      color: 'from-indigo-500 to-indigo-600',
      description: t('partners.list.3.description'),
      cooperation: t('partners.list.3.cooperation')
    },
    { 
      name: t('partners.list.4.name'),
      color: 'from-emerald-500 to-emerald-600',
      description: t('partners.list.4.description'),
      cooperation: t('partners.list.4.cooperation')
    },
    { 
      name: t('partners.list.5.name'),
      color: 'from-red-500 to-red-600',
      description: t('partners.list.5.description'),
      cooperation: t('partners.list.5.cooperation')
    },
    { 
      name: t('partners.list.6.name'),
      color: 'from-cyan-500 to-cyan-600',
      description: t('partners.list.6.description'),
      cooperation: t('partners.list.6.cooperation')
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t('partners.title')}</h2>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {partners.map((partner, index) => (
            <div
              key={index}
              onClick={() => setSelectedPartner(partner)}
              className="flex items-center justify-center p-8 bg-white rounded-lg border-2 border-gray-200 hover:border-orange-500 hover:shadow-xl transition-all duration-300 group cursor-pointer h-32"
            >
              <div className={`text-center w-full bg-gradient-to-r ${partner.color} bg-clip-text text-transparent group-hover:scale-110 transition-transform duration-300`}>
                <div className="font-bold text-lg leading-tight">{partner.name}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Partner Detail Modal */}
      {selectedPartner && (
        <div 
          className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedPartner(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-2xl w-full p-8 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedPartner(null)}
              className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer"
              aria-label={t('partners.close')}
            >
              <i className="ri-close-line text-2xl text-gray-600"></i>
            </button>

            <div className="flex items-center gap-6 mb-6 pb-6 border-b border-gray-200">
              <div className={`w-32 h-32 flex items-center justify-center bg-gradient-to-br ${selectedPartner.color} rounded-lg p-4`}>
                <div className="text-white font-bold text-2xl text-center leading-tight">
                  {selectedPartner.name}
                </div>
              </div>
              <div>
                <h3 className="text-3xl font-bold text-gray-900 mb-2">{selectedPartner.name}</h3>
                <div className="flex items-center gap-2 text-indigo-600">
                  <i className="ri-building-line"></i>
                  <span className="text-sm">{t('partners.strategicPartner')}</span>
                </div>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-information-line text-indigo-600"></i>
                  {t('partners.companyIntro')}
                </h4>
                <p className="text-gray-600 leading-relaxed">{selectedPartner.description}</p>
              </div>

              <div>
                <h4 className="text-lg font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <i className="ri-handshake-line text-indigo-600"></i>
                  {t('partners.cooperation')}
                </h4>
                <p className="text-gray-600 leading-relaxed">{selectedPartner.cooperation}</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-gray-200">
              <button
                onClick={() => setSelectedPartner(null)}
                className="w-full py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all duration-300 font-medium cursor-pointer whitespace-nowrap"
              >
                {t('partners.close')}
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
